// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__2DFHe","label":"Category_label__wcKxl","content":"Category_content__xaREB","header":"Category_header__13QH6","location":"Category_location__3XX2w"};